import script from "./Index.vue?vue&type=script&lang=ts&setup=true&name=archive"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true&name=archive"

const __exports__ = script;

export default __exports__